import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.join.js";
import platform from '../platform';
import Jsonp from '../utils/jsonp';
import Store from '../store';
import Event from '../event';
import UA from '../ua';
var KNBP = require('@dp/knb').getPromiseInstance();
var appName = platform.appName,
  useKNB = platform.useKNB,
  customGetCity = platform.getCity,
  customGetLocation = platform.getLocation;
var defLocation = {
  lat: 0,
  lng: 0
};
var isDianping = ['dianping', 'dianping_m'].includes(appName);
var defCity = isDianping ? {
  cityId: 1,
  cityName: '上海',
  type: '',
  def: true
} : {
  cityId: 10,
  cityName: '上海',
  type: 'mt',
  def: true
};
var cityStoreKey = 'city';
var locCityStoreKey = 'loccity';
var locationStoreKey = 'lat_lng';
var Geo = /*#__PURE__*/function () {
  function Geo() {
    _classCallCheck(this, Geo);
    this.latlng = defLocation;
    this.ci = defCity;
    this.locCi = defCity;
    this.defCi = defCity;
  }
  _createClass(Geo, [{
    key: "fetchLocation",
    value: function () {
      var _fetchLocation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var location,
          _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // 支持模拟
              location = {};
              if (!(_args.length === 2)) {
                _context.next = 5;
                break;
              }
              location = {
                lat: _args.length <= 0 ? undefined : _args[0],
                lng: _args.length <= 1 ? undefined : _args[1]
              }; // 用于模拟定位
              _context.next = 20;
              break;
            case 5:
              if (!useKNB) {
                _context.next = 11;
                break;
              }
              _context.next = 8;
              return KNBP.getLocation().then(function (res) {
                return res;
              }, function (fail) {
                return defLocation;
              }).catch(function (err) {
                console.warn(err);
              });
            case 8:
              location = _context.sent;
              _context.next = 20;
              break;
            case 11:
              if (!customGetLocation) {
                _context.next = 17;
                break;
              }
              _context.next = 14;
              return customGetLocation.call(this);
            case 14:
              location = _context.sent;
              _context.next = 20;
              break;
            case 17:
              _context.next = 19;
              return new Promise(function (resolve, reject) {
                navigator.geolocation.getCurrentPosition(function (_ref) {
                  var _ref$coords = _ref.coords,
                    latitude = _ref$coords.latitude,
                    longitude = _ref$coords.longitude;
                  return resolve({
                    lat: latitude.toFixed(4),
                    lng: longitude.toFixed(4)
                  });
                }, function (fail) {
                  Event.trigger('locationFail', true);
                  reject(defLocation);
                  return defLocation;
                });
              });
            case 19:
              location = _context.sent;
            case 20:
              location.lat && location.lng && this.setLocation(location);
              return _context.abrupt("return", location);
            case 22:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchLocation() {
        return _fetchLocation.apply(this, arguments);
      }
      return fetchLocation;
    }()
  }, {
    key: "getCity",
    value: function () {
      var _getCity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var city, locCity;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (this.ci.def) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", this.ci);
            case 2:
              city = defCity;
              if (!customGetCity) {
                _context2.next = 13;
                break;
              }
              _context2.next = 6;
              return customGetCity.call(this);
            case 6:
              city = _context2.sent;
              if (!(!city || !city.cityId)) {
                _context2.next = 11;
                break;
              }
              _context2.next = 10;
              return Store.get(locCityStoreKey);
            case 10:
              city = _context2.sent;
            case 11:
              _context2.next = 23;
              break;
            case 13:
              if (!(useKNB && UA.isNative)) {
                _context2.next = 19;
                break;
              }
              _context2.next = 16;
              return KNBP.getCity().then(function (data) {
                var type = data.type,
                  cityId = data.cityId,
                  cityName = data.cityName,
                  locCityId = data.locCityId,
                  locCityName = data.locCityName;
                // 兼容猫眼ios 只返回locCityId, locCityName
                cityId = cityId || locCityId;
                cityName = cityName || locCityName;
                return {
                  type: type,
                  cityId: cityId,
                  cityName: cityName
                };
              }).catch(function (err) {
                console.warn(err);
              });
            case 16:
              city = _context2.sent;
              _context2.next = 23;
              break;
            case 19:
              _context2.next = 21;
              return Store.get(cityStoreKey);
            case 21:
              locCity = _context2.sent;
              city = locCity || defCity;
            case 23:
              this.setCity(city);
              return _context2.abrupt("return", this.ci);
            case 25:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getCity() {
        return _getCity.apply(this, arguments);
      }
      return getCity;
    }()
  }, {
    key: "getCitySync",
    value: function getCitySync() {
      return this.ci;
    }
  }, {
    key: "setCity",
    value: function setCity(city) {
      if (city && !city.cityId) return;
      this.ci = Object.assign({}, city);
      if (city && !city.def) {
        Store.set(cityStoreKey, city, '999M');
      }
      Event.trigger('cityChange', city);
      return city;
    }
  }, {
    key: "setLocation",
    value: function setLocation(location) {
      try {
        var lat = location.lat,
          lng = location.lng;
        this.latlng = location;
        Event.trigger('locationChange', location);
        // 定位默认本地保存2小时
        Store.set(locationStoreKey, location, {
          expires: '2H'
        });
      } catch (error) {
        console.error(error);
      }
    }
  }, {
    key: "getLocCity",
    value: function () {
      var _getLocCity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!useKNB) {
                _context3.next = 6;
                break;
              }
              _context3.next = 3;
              return KNBP.getCity().then(function (data) {
                var cityId = data.cityId,
                  type = data.type,
                  cityName = data.cityName,
                  locCityId = data.locCityId,
                  locCityName = data.locCityName;
                // locCityId： 实际定位， cityid：当前全局定位
                return {
                  cityId: locCityId,
                  type: type,
                  cityName: locCityName,
                  locCityId: locCityId,
                  locCityName: locCityName
                };
              }).catch(function (err) {
                console.warn(err);
              });
            case 3:
              this.locCi = _context3.sent;
              _context3.next = 9;
              break;
            case 6:
              _context3.next = 8;
              return Store.get(locCityStoreKey);
            case 8:
              this.locCi = _context3.sent;
            case 9:
              if (this.locCi) {
                _context3.next = 16;
                break;
              }
              _context3.next = 12;
              return this._locationCity();
            case 12:
              _context3.t0 = _context3.sent;
              if (_context3.t0) {
                _context3.next = 15;
                break;
              }
              _context3.t0 = defCity;
            case 15:
              this.locCi = _context3.t0;
            case 16:
              return _context3.abrupt("return", this.locCi);
            case 17:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getLocCity() {
        return _getLocCity.apply(this, arguments);
      }
      return getLocCity;
    }()
  }, {
    key: "getLocCitySync",
    value: function getLocCitySync() {
      return this.locCi;
    }
  }, {
    key: "getLocation",
    value: function () {
      var _getLocation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this$latlng, lat, lng, locLocation;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this$latlng = this.latlng, lat = _this$latlng.lat, lng = _this$latlng.lng; // 存在 直接 返回
              if (!(lat && lng)) {
                _context4.next = 3;
                break;
              }
              return _context4.abrupt("return", this.latlng);
            case 3:
              if (!customGetLocation) {
                _context4.next = 9;
                break;
              }
              _context4.next = 6;
              return customGetLocation.call(this);
            case 6:
              this.latlng = _context4.sent;
              _context4.next = 19;
              break;
            case 9:
              if (!useKNB) {
                _context4.next = 15;
                break;
              }
              _context4.next = 12;
              return KNBP.getLocation().then(function (_ref2) {
                var lat = _ref2.lat,
                  lng = _ref2.lng;
                return {
                  lat: lat,
                  lng: lng
                };
              }, function (fail) {
                return defLocation;
              }).catch(function (err) {
                console.warn(err);
              });
            case 12:
              this.latlng = _context4.sent;
              _context4.next = 19;
              break;
            case 15:
              _context4.next = 17;
              return Store.get(locationStoreKey);
            case 17:
              locLocation = _context4.sent;
              return _context4.abrupt("return", locLocation || defLocation);
            case 19:
              return _context4.abrupt("return", this.latlng);
            case 20:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getLocation() {
        return _getLocation.apply(this, arguments);
      }
      return getLocation;
    }()
  }, {
    key: "locCity",
    get: function get() {
      return this.locCi;
    }
  }, {
    key: "city",
    get: function get() {
      return this.ci;
    }
  }, {
    key: "location",
    get: function get() {
      return this.latlng;
    }
  }, {
    key: "_locationCity",
    value: function _locationCity() {
      var _this = this;
      // 招行内，本地city为getcity接口返回，不需要模拟
      if (appName === 'cmb_app') {
        Store.set(locCityStoreKey, this.ci, {
          expires: '2H'
        });
        return this.ci;
      }

      // 支持模拟
      return this.fetchLocation.apply(this, arguments).then(function (_ref3) {
        var lat = _ref3.lat,
          lng = _ref3.lng;
        if (lat === 0 || lng === 0) {
          Event.trigger('locationfail', true);
          throw new Error('location fail');
        }
        return new Jsonp("https://apimobile.meituan.com/group/v1/city/latlng/".concat([lat, lng].join(','), "?tag=1")).then(function (_ref4) {
          var _ref4$data = _ref4.data,
            city = _ref4$data.city,
            district = _ref4$data.district,
            detail = _ref4$data.detail,
            dpCityId = _ref4$data.dpCityId,
            id = _ref4$data.id,
            cityPinyin = _ref4$data.cityPinyin;
          var data = {
            cityName: city,
            detail: district + detail,
            type: isDianping ? 'dp' : 'mt',
            cityId: isDianping ? dpCityId : id,
            pinyin: cityPinyin,
            def: false
          };
          Event.trigger('locCityChange', data);
          if (_this.getCitySync() && (_this.getCitySync().def || !_this.getCitySync().cityId)) {
            _this.setCity(data);
          }
          Store.set(locCityStoreKey, data, {
            expires: '2H'
          });
          return data;
        }).catch(function (err) {
          console.warn(err);
        });
      }).catch(function (err) {
        console.warn(err);
      });
    }
  }]);
  return Geo;
}();
export default new Geo();